import {
  PATIENT_INFO,
  BACK_NAVIGATION,
  VIEW_PDF,
  SIGNATURE_ACKNOWLEDGEMENT,
  PATIENT_PROCEDURE,
  TIME_STAMP,
  SET_TIME,
  USER_INFO,
  CLEAR_USER_INFO,
  UPDATE_NAVIAGTION_STATUS,
  DISABLE_BUTTONS,
  DISABLE_LINEAND_BUTTON,
  UPDATE_SURGERY_TIMES,
  UPDATE_SURGERY_TIMES_CLICKABLE,
  UPDATE_SURGERY_TIMES_ACTIVE,
  // SIGNATURE_TIMES_ACKNOWLEDGEMENT,
  TIMER_ACKNOWLEDGEMENT,
  TIMER_MODALITY_ACKNOWLEDGEMENT,
  FLASH_ACKNOWLEDGEMENT,
  CLOSE_TIMESTAMP,
  CASES_COUNT_ACKNOWLEDGEMENT,
  SNACKBAR_ACKNOWLEDGEMENT,
  DATE_OF_SERVICE,
  PATIENT_DATE,
  ANESTHETIC_INFUSION_TIME,
  ATBR_PDF_ACKNOWLEDGEMENT,
  SELECTED_MODALITY,
  TIMERMINSEC,
  PREVIEWATBRTIMESTAMP,
  UPDATEVITALSCOUNT,
  ENABLEMODALITIES,
  SELECTEDDATE,
  UPLOAD_DOCUMENTS,
  IS_PATIENT_DOCUMENT_DETAILS,
  SELECTED_DOUMENT_SUBMISSION_DETAILS_ID,
  SELECTED_DOUMENT_SUBMISSION_DETAILS_CASE_PID,
  IS_REFRESH_QUEUE_SUBMITTED_DOCUMENTS,
  IS_OPEN_UPLOAD_NEW_DOUMENT_MODAL,
  SHOW_OFFLINE_TOGGLE_BUTTON,
  SELECTED_ACTIVE_TAB,
  IS_PATIENT_FORM_DETAILS,
  SET_ACTIVE_PARENT_TAB,
  // these are the functions to save and reset the patient form
  UPDATE_PATIENT_FORM_FIELD,
  SET_PATIENT_FORM_DATA,
  CLEAR_PATIENT_FORM_DATA,
  PATIENT_FORMS_SUBMIT_REQUEST,
  PATIENT_FORMS_SUBMIT_CLEAR,

  SET_PATIENT_FORMS_VALIDATION_ERRORS,
  CLEAR_PATIENT_FORMS_VALIDATION_ERRORS,
  SET_PATIENT_FORMS_SAVING,
  TRIGGER_PATIENT_FORMS_REFRESH,
  IS_SURGEON_FORM_DETAILS,
  SELECTED_SURGEON_ID,
  SELECTED_SURGEON_NAME,
  SET_SURGEON_FORMS_DATA,
  CLEAR_SURGEON_FORMS_DATA,
  UPDATE_UNSAVED_ANESTHETIC_INFUSION,
  CLEAR_UNSAVED_ANESTHETIC_INFUSION
} from '../actions/Index';

// Defining the initial state for the reducer
const initState = {
  headerInfo: true,
  patientName: null,
  dob: null,
  procedure: null,
  statusCards: true,
  userInfo: false,
  headerBar: true,
  viewPdf: false,
  route: null,
  patientProcedure: false,
  timeStamp: false,
  hours: '',
  minutes: '',
  headerType: null,
  timeStampLeft: '',
  headerConsultTime: 'Start',
  headerInRoomTime: 'Start',
  headerBaseLineTime: 'Start',
  headerIncisionTime: 'Start',
  headerCloseTime: 'Start',
  headerOutOfRoomTime: 'Start',
  headerNeuroCheckTime: 'Start',
  consultActive: true,
  inRoomActive: false,
  baseLineActive: false,
  incisionActive: false,
  closeActive: false,
  outOfRoomActive: false,
  neuroCheckActive: false,
  userName: '',
  userId: '',
  webId: '',
  backNavigationStatus: false,
  isPatientDocumentDetails: false, // Flag to handle patient document details view
  buttonsDisabled: false,
  alertDisabled: false,
  consultClickable: false,
  inRoomClickable: true,
  baseLineClickable: true,
  incisionClickable: true,
  closeClickable: true,
  outOfRoomClickable: true,
  neuroCheckClickable: true,
  isInProcedure: true,
  isTimerStarted: false,
  recordedVitalsCount: 0,
  isNewTimerStarted: false,
  captureVitalsMinutes: '',
  captureVitalsSecs: '',
  isCaptureTimerStarted: false,
  modalityUpdated: false,
  flashScreenEnabled: false,
  toDayCasescount: 0,
  assignedCasesCount: 0,
  openedCasesCount: 0,
  snackBarEnabled: false,
  snackBarMessage: 'Please pass porper message and type',
  snackBarType: 'warning',
  dos: null,
  azureId: '',
  userType: '',
  actualUserId: '',
  actualWebId: '',
  actualToken: '',
  flowHeaderDate: new Date().getDate(),
  flowHeaderMonth: new Date().getMonth(),
  flowHeaderYear: new Date().getFullYear(),
  anestheticInfusionTime: null,
  atbrPId: null,
  selectedModalityId: null,
  timerMinutes: null,
  timerSecs: null,
  previewAtbrTimeStamp: null,
  canImpersonate: false,
  lowerSsepEnable: false,
  upperMepEnable: false,
  lowerMepExpand: false,
  transabdominalExpand: false,
  upperEmgExpand: false,
  lowerEmgExpand: false,
  absAxialEmgExpand: false,
  graniEmgExpand: false,
  analSphincterEmgExpand: false,
  urethralSphincterEmgExpand: false,
  triggeredEmgExpand: false,
  hreflexEmgExpand: false,
  snapEmgExpand: false,
  vepEmgExpand: false,
  dssepExpand: false,
  baepExpand: false,
  mappingExpand: false,
  lateralApproachExpand: false,
  eegExpand: false,
  otherExpand: false,
  upperSsepExpand: false,
  to4Expand: false,
  selectedDate: '',
  uploadedFiles: [],
  selectedRowDocumentSubmissionDetailsId: null,
  selectedDocumentSubmissionDetailsCasePID: null,
  isPatientFormDetails: false,
  isRefreshQueueSubmittedDocuments: false, // added to check whether to refresh the queue submitted documents or not
  isOpenUploadNewDocumentModal: false, // added to open up the upload New document modal,
  showOfflineButton: false,
  activeTab: 'Cases',
  activeParentTab: 'Cases',
  //** Patient Forms Data ** //
  patientFormData: {
    // non editable fields in UI in disabled state
    patient_name: '',
    medical_record_no: '',
    dob: '',
    patient_hospital_id: '',
    sex: '',
    date_of_service: '',
    primary_insurance_policy_number: '',
    primary_insurance_provider: '',
    procedure: '',
    procedure_state: '',
    // editable fields in UI
    patient_phone: '',
    email1: '',
    email2: '',
    email3: '',
    electronic_communication_consent: false,
    technician: '',
    tech_company: '',
    interpreting_physician: '',
    professional_company: '',
    feature_access: [] as string[],
    diagnosis: '',
  },
  // NEW flag for “please submit patient forms now”
  submitPatientFormsRequested: false,
  patientFormsValidationErrors: {},
  patientFormsSaving: false,
  refreshCounter: 0,
  isSurgeonFormDetails: false,
  selectedSurgeonId: null,
  selectedSurgeonName: '',
  surgeonFormsData: [],
  unsavedAnestheticInfusion: null,
  patientFormDataUpdatedAt: 0,
};
export default function (state = initState, action: any): any {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_DOCUMENTS:
      return {
        ...state,
        uploadedFiles: [...state.uploadedFiles, payload.files]
      };
    case PATIENT_INFO:
      return {
        ...state,
        headerInfo: payload.headerInfo,
        patientName: payload.patientName,
        dob: payload.dob,
        procedure: payload.procedure,
        userInfo: payload.userInfo,
        statusCards: payload.statusCards,
        id: payload.id,
        route: payload.route,
        backNavigationStatus: payload.backNavigationStatus,
        isPatientDocumentDetails: payload.isPatientDocumentDetails
      };
    case IS_PATIENT_DOCUMENT_DETAILS:
      return {
        ...state,
        isPatientDocumentDetails: payload.isPatientDocumentDetails
      };
    case SELECTED_DOUMENT_SUBMISSION_DETAILS_ID:
      return {
        ...state,
        selectedRowDocumentSubmissionDetailsId: payload.selectedRowDocumentSubmissionDetailsId
      };
    case SELECTED_DOUMENT_SUBMISSION_DETAILS_CASE_PID:
      return {
       ...state,
       selectedDocumentSubmissionDetailsCasePID: payload.selectedRowDocumentSubmissionCasePID
      };
    case IS_REFRESH_QUEUE_SUBMITTED_DOCUMENTS:
      return {
        ...state,
        isRefreshQueueSubmittedDocuments: payload.isRefreshQueueSubmittedDocuments
      };
    case IS_OPEN_UPLOAD_NEW_DOUMENT_MODAL:
        return {
          ...state,
          isOpenUploadNewDocumentModal: payload.isOpenUploadNewDocumentModal
        };
        case SHOW_OFFLINE_TOGGLE_BUTTON:
          return {
           ...state,
            showOfflineButton: payload.showOfflineButton
          };
          case SELECTED_ACTIVE_TAB:
            return {
             ...state,
             activeTab: payload.activeTab
            };
          
    case BACK_NAVIGATION:
      return {
        ...state,
        headerInfo: payload.headerInfo,
        patientName: payload.patientName,
        dob: payload.dob,
        procedure: payload.procedure,
        userInfo: payload.userInfo,
        statusCards: payload.statusCards,
        patientProcedure: payload.patientProcedure,
        backNavigationStatus: payload.backNavigationStatus,
        timeStamp: false,
        isInProcedure: true
      };
    case VIEW_PDF:
      return {
        ...state,
        headerBar: payload.headerBar,
        viewPdf: payload.viewPdf,
        route: payload.route,
        patientProcedure: payload.patientProcedure
      };
    case ATBR_PDF_ACKNOWLEDGEMENT:
      return {
        ...state,
        atbrPId: payload.atbrPId
      };
    case CLOSE_TIMESTAMP:
      return {
        ...state,
        timeStamp: payload.timeStamp
      };
    case SIGNATURE_ACKNOWLEDGEMENT:
      return {
        ...state,
        headerBar: payload.headerBar
      };
    case CASES_COUNT_ACKNOWLEDGEMENT:
      return {
        ...state,
        toDayCasescount: payload.toDayCasescount,
        assignedCasesCount: payload.assignedCasesCount,
        openedCasesCount: payload.openedCasesCount
      };
    case TIMER_ACKNOWLEDGEMENT:
      return {
        ...state,
        isTimerStarted: payload.isTimerStarted,
        recordedVitalsCount: payload.recordedVitalsCount,
        isNewTimerStarted: payload.isNewTimerStarted,
        isCaptureTimerStarted: payload.isCaptureTimerStarted,
        captureVitalsMinutes: payload.captureVitalsMinutes,
        captureVitalsSecs: payload.captureVitalsSecs
      };
    case TIMER_MODALITY_ACKNOWLEDGEMENT:
      return {
        ...state,
        modalityUpdated: payload.modalityUpdated
      };
    case FLASH_ACKNOWLEDGEMENT:
      return {
        ...state,
        flashScreenEnabled: payload.flashScreenEnabled
      };
    case SNACKBAR_ACKNOWLEDGEMENT:
      return {
        ...state,
        snackBarEnabled: payload.snackBarEnabled,
        snackBarMessage: payload.snackBarMessage,
        snackBarType: payload.snackBarType
      };
    case PATIENT_PROCEDURE:
      return {
        ...state,
        patientProcedure: payload.patientProcedure
      };
    case TIME_STAMP:
      return {
        ...state,
        timeStamp: payload.timeStamp,
        headerType: payload.headerType,
        timeStampLeft: payload.timeStampLeft,
        selectedDate: payload.selectedDate
      };
    case USER_INFO:
      return {
        ...state,
        userName: payload.userName,
        userId: payload.userId,
        webId: payload.webId,
        azureId: payload.azureId,
        userType: payload.userType,
        actualUserId: payload.actualUserId,
        actualWebId: payload.actualWebId,
        actualToken: payload.actualToken,
        canImpersonate: payload.canImpersonate
      };
    case CLEAR_USER_INFO:
      return {
        ...initState
      };
    case UPDATE_NAVIAGTION_STATUS:
      return {
        ...state,
        backNavigationStatus: payload.backNavigationStatus
      };
    case UPDATE_SURGERY_TIMES:
      return {
        ...state,
        headerConsultTime: payload.headerConsultTime,
        headerInRoomTime: payload.headerInRoomTime,
        headerBaseLineTime: payload.headerBaseLineTime,
        headerIncisionTime: payload.headerIncisionTime,
        headerCloseTime: payload.headerCloseTime,
        headerOutOfRoomTime: payload.headerOutOfRoomTime,
        headerNeuroCheckTime: payload.headerNeuroCheckTime
      };
    case UPDATE_SURGERY_TIMES_CLICKABLE:
      return {
        ...state,
        consultClickable: payload.consultClickable,
        inRoomClickable: payload.inRoomClickable,
        baseLineClickable: payload.baseLineClickable,
        incisionClickable: payload.incisionClickable,
        closeClickable: payload.closeClickable,
        outOfRoomClickable: payload.outOfRoomClickable,
        neuroCheckClickable: payload.neuroCheckClickable
      };
    case UPDATE_SURGERY_TIMES_ACTIVE:
      return {
        ...state,
        consultActive: payload.consultActive,
        inRoomActive: payload.inRoomActive,
        baseLineActive: payload.baseLineActive,
        incisionActive: payload.incisionActive,
        closeActive: payload.closeActive,
        outOfRoomActive: payload.outOfRoomActive,
        neuroCheckActive: payload.neuroCheckActive
      };
    case DISABLE_BUTTONS:
      return {
        ...state,
        buttonsDisabled: payload.buttonsDisabled,
        alertDisabled: payload.alertDisabled
      };
    case DISABLE_LINEAND_BUTTON:
      return {
        ...state,
        isInProcedure: payload.disableLineAndButton
      };

    case DATE_OF_SERVICE:
      return {
        ...state,
        dos: payload.dos
      };

    case PATIENT_DATE:
      return {
        ...state,
        flowHeaderDate: payload.date,
        flowHeaderMonth: payload.month,
        flowHeaderYear: payload.year
      };

    case ANESTHETIC_INFUSION_TIME:
      return {
        ...state,
        anestheticInfusionTime: payload.anestheticInfusionTime
      };

    case SELECTED_MODALITY:
      return {
        ...state,
        selectedModalityId: payload.selectedModalityId
      };
    case TIMERMINSEC:
      return {
        ...state,
        timerMinutes: payload.timerMinutes,
        timerSecs: payload.timerSecs
      };
    case PREVIEWATBRTIMESTAMP:
      return {
        ...state,
        previewAtbrTimeStamp: payload.previewAtbrTimeStamp
      };
    case UPDATEVITALSCOUNT:
      return {
        ...state,
        recordedVitalsCount: payload.vitalsCount
      };
    case ENABLEMODALITIES:
      return {
        ...state,
        lowerSsepEnable: payload.type === 'lower_ssep' ? payload.modalityEnable : state.lowerSsepEnable,
        upperMepEnable: payload.type === 'upper_mep' ? payload.modalityEnable : state.upperMepEnable,
        lowerMepExpand: payload.type === 'lower_mep' ? payload.modalityEnable : state.lowerMepExpand,
        transabdominalExpand: payload.type === 'transabdominal_mep' ? payload.modalityEnable : state.transabdominalExpand,
        upperEmgExpand: payload.type === 'upper_emg' ? payload.modalityEnable : state.upperEmgExpand,
        lowerEmgExpand: payload.type === 'lower_emg' ? payload.modalityEnable : state.lowerEmgExpand,
        absAxialEmgExpand: payload.type === 'abs_axial_emg' ? payload.modalityEnable : state.absAxialEmgExpand,
        graniEmgExpand: payload.type === 'grani_emg' ? payload.modalityEnable : state.graniEmgExpand,
        analSphincterEmgExpand: payload.type === 'anal_sphincter_emg' ? payload.modalityEnable : state.analSphincterEmgExpand,
        urethralSphincterEmgExpand: payload.type === 'urethral_sphincter_emg' ? payload.modalityEnable : state.urethralSphincterEmgExpand,
        triggeredEmgExpand: payload.type === 'triggered_emg' ? payload.modalityEnable : state.triggeredEmgExpand,
        hreflexEmgExpand: payload.type === 'hreflex' ? payload.modalityEnable : state.hreflexEmgExpand,
        snapEmgExpand: payload.type === 'snap' ? payload.modalityEnable : state.snapEmgExpand,
        vepEmgExpand: payload.type === 'vep' ? payload.modalityEnable : state.vepEmgExpand,
        dssepExpand: payload.type === 'dssep' ? payload.modalityEnable : state.dssepExpand,
        baepExpand: payload.type === 'baep' ? payload.modalityEnable : state.baepExpand,
        mappingExpand: payload.type === 'mapping' ? payload.modalityEnable : state.mappingExpand,
        lateralApproachExpand: payload.type === 'lateral_approach' ? payload.modalityEnable : state.lateralApproachExpand,
        eegExpand: payload.type === 'eeg' ? payload.modalityEnable : state.eegExpand,
        otherExpand: payload.type === 'other_modality' ? payload.modalityEnable : state.otherExpand,
        upperSsepExpand: payload.type === 'upper_ssep' ? payload.modalityEnable : state.upperSsepExpand,
        to4Expand: payload.type === 'to4' ? payload.modalityEnable : state.to4Expand,
      }
    case SELECTEDDATE:
      return {
        selectedDate: payload.selectedDate
      }

    case SET_TIME:
      if (state.headerType === 'consult')
        return {
          ...state,
          hours: payload.hours,
          minutes: payload.minutes,
          timeStamp: payload.timeStamp,
          headerConsultTime: payload.hedaderTime,
          consultActive: true,
        };
      else if (state.headerType === 'inRoom')
        return {
          ...state,
          hours: payload.hours,
          minutes: payload.minutes,
          timeStamp: payload.timeStamp,
          headerInRoomTime: payload.hedaderTime,
          inRoomActive: true,
        };
      else if (state.headerType === 'baseLine')
        return {
          ...state,
          hours: payload.hours,
          minutes: payload.minutes,
          timeStamp: payload.timeStamp,
          headerBaseLineTime: payload.hedaderTime,
          baseLineActive: true,
        };
      else if (state.headerType === 'incision')
        return {
          ...state,
          hours: payload.hours,
          minutes: payload.minutes,
          timeStamp: payload.timeStamp,
          headerIncisionTime: payload.hedaderTime,
          incisionActive: true,
        };
      else if (state.headerType === 'close')
        return {
          ...state,
          hours: payload.hours,
          minutes: payload.minutes,
          timeStamp: payload.timeStamp,
          headerCloseTime: payload.hedaderTime,

          closeActive: true,
        };
      else if (state.headerType === 'outOfRoom')
        return {
          ...state,
          hours: payload.hours,
          minutes: payload.minutes,
          timeStamp: payload.timeStamp,
          headerOutOfRoomTime: payload.hedaderTime,
          outOfRoomActive: true,
        };
      else if (state.headerType === 'neuroCheck')
        return {
          ...state,
          hours: payload.hours,
          minutes: payload.minutes,
          timeStamp: payload.timeStamp,
          headerNeuroCheckTime: payload.hedaderTime,

          neuroCheckActive: true
        };
    case IS_PATIENT_FORM_DETAILS:
      return {
        ...state,
        isPatientFormDetails: payload.isPatientFormDetails,
      };
    case SET_ACTIVE_PARENT_TAB:
      return {
        ...state,
        activeParentTab: action.payload
      };
    // these are the functions to save and reset the patient form
    case UPDATE_PATIENT_FORM_FIELD:
      return {
        ...state,
        // set the patient form data
        patientFormData: {
          ...state.patientFormData,
          [action.payload.fieldKey]: action.payload.value
        }
      };
    case SET_PATIENT_FORM_DATA:
      return {
        ...state,
        // set the patient form data
        patientFormData: { ...action.payload },
        patientFormDataUpdatedAt: Date.now(),
      };
    case CLEAR_PATIENT_FORM_DATA:
      return {
        ...state,
        // reset back to initial defaults for patient form data
        patientFormData: { ...initState.patientFormData }
      };
    // set the “please run validation+save” flag
    case PATIENT_FORMS_SUBMIT_REQUEST:
      return {
        ...state,
        submitPatientFormsRequested: payload.submitRequested
        // submitPatientFormsRequested: true
      };
    // NEW: clear it once handled
    case PATIENT_FORMS_SUBMIT_CLEAR:
      return {
        ...state,
        submitPatientFormsRequested: false
      };
    case SET_PATIENT_FORMS_VALIDATION_ERRORS:
      return {
        ...state,
        patientFormsValidationErrors: action.payload
      };

    case CLEAR_PATIENT_FORMS_VALIDATION_ERRORS:
      return {
        ...state,
        patientFormsValidationErrors: {}
      };

    case SET_PATIENT_FORMS_SAVING:
      return {
        ...state,
        patientFormsSaving: action.payload
      };
    case TRIGGER_PATIENT_FORMS_REFRESH:
      return {
        ...state,
        refreshCounter: state.refreshCounter + 1
        };
    case IS_SURGEON_FORM_DETAILS:
      return {
        ...state,
        isSurgeonFormDetails: payload.isSurgeonFormDetails,
      };
    case SELECTED_SURGEON_ID:
      return {
        ...state,
        selectedSurgeonId: payload.selectedSurgeonId,
      };
    case SELECTED_SURGEON_NAME:
      return {
        ...state,
        selectedSurgeonName: payload.selectedSurgeonName,
      };
    case SET_SURGEON_FORMS_DATA:
      return {
        ...state,
        surgeonFormsData: payload,
      };
    case CLEAR_SURGEON_FORMS_DATA:
      return {
        ...state,
        surgeonFormsData: [],
        selectedSurgeonId: null,
        isSurgeonFormDetails: false
      };
    case UPDATE_UNSAVED_ANESTHETIC_INFUSION:
      return {
        ...state,
        unsavedAnestheticInfusion: action.payload
      };
    case CLEAR_UNSAVED_ANESTHETIC_INFUSION:
      return {
        ...state,
        unsavedAnestheticInfusion: null
      };
    // eslint-disable-next-line no-fallthrough
    default:
      return state;
  }
}